const initialState = {
  loading: false,
  data: null,
  error: null,
  searchData: null,
  // hasMore: true,
  // filter: "",
};

const userOwnTournamentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_USER_OWN_TOURNAMENT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_USER_OWN_TOURNAMENT_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_USER_OWN_TOURNAMENT_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "EMPTY_MYTOURNAMENTS_STATE":
      return {
        loading: false,
        data: null,
        error: null,
      };

    case "FETCH_USER_OWN_TOURNAMENT_SEARCH_SUCCESS":
      return {
        ...state,
        loading: false,
        searchData: action.payload,
      };
    case "FETCH_USER_OWN_TOURNAMENT_SEARCH_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "EMPTY_USER_OWN_TOURNAMENT_SEARCH":
      return {
        ...state,
        searchData: null,
        error: null,
        loading: false,
      };

    // case "FETCH_USER_GOAL_SUCCESS_ADD":
    //   return {
    //     ...state,
    //     loading: false,
    //     data: [...state.data, ...action.payload],
    //     hasMore: action.payload.length > 0,
    //   };
    // case "USER_GOALS_CHANGE_FILTERS":
    //   return {
    //     ...state,
    //     filter: action.payload,
    //   };
    default:
      return state;
  }
};

export default userOwnTournamentReducer;
